const config = {
  siteName: "EventHaze India",
  contactEmail: "eventhaze.mysore@startmail.com",
  contactAddress: "Mall of Mysore, MG Road, Mysuru, Karnataka 570010, India",
  tel: "+91 821 665 7788",
  maintenanceMode: false,
  requireAgeVerification: false,
  minimumAge: 18
};

export function useConfig() {
  return config;
}